import React from 'react';

import { Button, CardBody, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { isFieldFocused, shouldHighlightText } from '../../helpers/validation';
import type { FocusedField } from '../../types';

type EndorsementCardBodyContentProps = {
	displayDescription: string;
	isDescriptionPlaceholder: boolean;
	focusedField: FocusedField;
	onReadMore?: () => void;
	readMoreLabel?: string;
};

export const EndorsementCardBodyContent: React.FC<EndorsementCardBodyContentProps> = ({
	displayDescription,
	isDescriptionPlaceholder,
	focusedField,
	onReadMore,
	readMoreLabel,
}) => {
	const isStatementFocused = isFieldFocused('statement', focusedField);
	const shouldHighlightDescription = shouldHighlightText(isStatementFocused, !isDescriptionPlaceholder);

	return (
		<CardBody className="p-0!">
			<Text
				as="p"
				className={cn(
					'leading-7 whitespace-pre-line',
					isDescriptionPlaceholder && 'text-typography-weak!',
					shouldHighlightDescription && 'text-typography-interactive!',
				)}
				expressive
			>
				{displayDescription}
			</Text>
			{onReadMore && readMoreLabel && (
				<Button
					onClick={onReadMore}
					className="text-typography-strong mt-4 -ml-4"
					data-testid="endorsement-toggle-button"
					variant="tertiary"
					size="x-small"
				>
					{readMoreLabel}
				</Button>
			)}
		</CardBody>
	);
};
